// Prefill defaults for the race-admin "New raceclass" drawer.
// year comes from the parent race's startDate; falls back to the current year.

function deriveRaceClassDefaults(race = {}, now = new Date()) {
    const startDate = race.startDate ? new Date(race.startDate) : null;
    const hasValidStartDate = startDate !== null && !Number.isNaN(startDate.getTime());
    return {
        race: race.id,
        year: hasValidStartDate ? startDate.getFullYear() : now.getFullYear(),
    };
}

export { deriveRaceClassDefaults };

export default { deriveRaceClassDefaults };
